import React from "react";
import AppHeader from "../../pages/LandingPage/AppHeader/AppHeader";
import LandingPageFooter from "../../pages/LandingPage/LandingPageFooter/FooterForLandingPage";

const AppHeaderFooterLayout = ({ children }) => {
  return (
    <div className="app_header_footer_layout">
      <div >
        <AppHeader />
      </div>
      <main style={{ flex: 1 }}>
        {children}
      </main>
      <LandingPageFooter />
    </div>
  );
};

export default AppHeaderFooterLayout;
